import type { LatLng } from '../maps/types';

export interface OdPair {
  from: LatLng;
  to: LatLng;
}

/** Round coords for OD cache / matrix keys (≈1.1 m at equator). */
export function roundCoord(n: number, decimals = 5): number {
  const f = 10 ** decimals;
  return Math.round(n * f) / f;
}

export function routeOdKey(from: LatLng, to: LatLng): string {
  return `${roundCoord(from.lat)},${roundCoord(from.lng)}>${roundCoord(to.lat)},${roundCoord(to.lng)}`;
}

export function sameRoutePoint(a: LatLng, b: LatLng): boolean {
  return roundCoord(a.lat) === roundCoord(b.lat) && roundCoord(a.lng) === roundCoord(b.lng);
}
